import type {
  FamilyAdditionalInfoType,
  IFamily,
  IFamilyValueItem,
} from '../../../../../pages/common';
import type { IIntakeQuestionnaireDetails } from '../../types';

// The family child-create responses return only the created row, not the family, so lazily
// initialize the family when it's still null instead of dropping the row (id is unused in the
// UI and corrected on refetch).
export function ensureIntakeFamily(details: IIntakeQuestionnaireDetails): IFamily {
  if (!details.family) {
    details.family = {
      id: 0,
      cultural_consideration: null,
      family_members: [],
      client_siblings: [],
      maternal_medical_history: [],
      paternal_medical_history: [],
      community_support: [],
    };
  }
  return details.family;
}

export function getIntakeFamilyAdditionalInfoArray(
  family: IFamily,
  type: FamilyAdditionalInfoType,
): IFamilyValueItem[] {
  if (type === 'MATERNAL_MEDICAL_HISTORY') return family.maternal_medical_history;
  if (type === 'PATERNAL_MEDICAL_HISTORY') return family.paternal_medical_history;
  return family.community_support;
}

export function setIntakeFamilyAdditionalInfoArray(
  family: IFamily,
  type: FamilyAdditionalInfoType,
  next: IFamilyValueItem[],
) {
  if (type === 'MATERNAL_MEDICAL_HISTORY') {
    family.maternal_medical_history = next;
    return;
  }
  if (type === 'PATERNAL_MEDICAL_HISTORY') {
    family.paternal_medical_history = next;
    return;
  }
  family.community_support = next;
}
